//  /////////////// COPYRIGHT © 2025/2026 IROÏD/DSTRKT™ FOR TIXFORGIGS
//  ////////////////////////////////////////////// ALL RIGHTS RESERVED
//  /////// LICENSED UNDER THE IROÏD LICENSE VERSION 1.0 [THE LICENSE]
//  /////// DO NOT USE THIS FILE EXCEPT IN COMPLIANCE WITH THE LICENSE
//
//  TixforGigs™ Unified API
//
//  VERSION: 4.6
//  PACKAGE: 4.6.297-SNAPSHOT
//  CONTACT: developer@tixforgigs.com
//  CREATED: 2026-02-26T01:20:10.489677Z
//
//  /////////////////////////////////////// AUTOGENERATED. DO NOT EDIT

@file:Suppress(
  "ArrayInDataClass",
  "EnumEntryName",
  "RemoveRedundantQualifierName",
  "UnusedImport"
)

package com.tixforgigs.apax.models


        import kotlinx.serialization.*
  import kotlinx.serialization.descriptors.*
  import kotlinx.serialization.encoding.*

/**
* The seats ticket type model
* 
* @param ticketType The ticket type as String
* @param description the ticket description
* @param label the ticket label
* @param price the price in cents
*/
@Serializable

data class FloorPlanTicketType (


      /* The ticket type as String */
    @SerialName(value = "ticketType") @Required val ticketType: kotlin.String,


      /* the ticket description */
    @SerialName(value = "description") val description: kotlin.String? = null,


      /* the ticket label */
    @SerialName(value = "label") val label: kotlin.String? = null,


      /* the price in cents */
    @SerialName(value = "price") val price: kotlin.Int? = null


) {




  }

